import axios from "axios";

const getBaseURL = () => {
  let url = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

  if (typeof window !== "undefined" && window.location.protocol === "https:" && url.startsWith("http://")) {
    const isLocal = url.includes("localhost") || url.includes("127.0.0.1");
    if (!isLocal) {
      url = url.replace("http://", "https://");
    }
  }

  // Remove trailing slash
  if (url.endsWith("/")) {
    url = url.slice(0, -1);
  }

  // If user specified /api in the environment variable, strip it so it
  // becomes the base domain (which is needed for media / photo URLs)
  if (url.endsWith("/api")) {
    url = url.slice(0, -4);
  }

  return url;
};

export const API_BASE_URL = getBaseURL();
export const API_URL = `${API_BASE_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // ❗ DO NOT force redirect here
      console.warn("Unauthorized – handled by ProtectedRoute");
    }
    return Promise.reject(error);
  }
);

export default api;
